<template>
  <div>
    <div
      class="flex flex-wrap"
      style="width: 100%"
    >
      <div class="input half-width">
        <LabeledField
          label="First Name*"
          data-test="first-name"
        >
          <InputText
            id="firstName"
            size="large"
            formType="text"
            :invalid-text="
              donorStore.errors.firstName || (donorStore.donorInfo.firstName === '' ? 'First name is required' : '')
            "
            :invalid="!!donorStore.errors.firstName || donorStore.donorInfo.firstName === ''"
            @input="
              (val) => {
                donorStore.donorInfo.firstName = val.target.value;
                if (donorStore.donorInfo.firstName === '') {
                  donorStore.errors.firstName = 'First name is required';
                } else {
                  donorStore.errors.firstName = '';
                }
              }
            "
            v-model="donorStore.donorInfo.firstName"
            data-test="first-name-input"
          >
          </InputText>
        </LabeledField>
      </div>
      <div class="input half-width">
        <LabeledField
          label="Middle Name"
          data-test="middle-name"
        >
          <InputText
            size="large"
            formType="text"
            @input="(val) => (donorStore.donorInfo.middleName = val.target.value)"
            v-model="donorStore.donorInfo.middleName"
            data-test="middle-name-input"
          >
          </InputText>
        </LabeledField>
      </div>
      <div class="input half-width">
        <LabeledField
          label="Last Name*"
          data-test="last-name"
        >
          <InputText
            size="large"
            formType="text"
            :invalid-text="
              donorStore.errors.lastName || (donorStore.donorInfo.lastName === '' ? 'Last name is required' : '')
            "
            :invalid="!!donorStore.errors.lastName || donorStore.donorInfo.lastName === ''"
            @input="
              (val) => {
                donorStore.donorInfo.lastName = val.target.value;
                if (donorStore.donorInfo.lastName === '') {
                  donorStore.errors.lastName = 'Last name is required';
                } else {
                  donorStore.errors.lastName = '';
                }
              }
            "
            v-model="donorStore.donorInfo.lastName"
            data-test="last-name-input"
          >
          </InputText>
        </LabeledField>
      </div>
      <div class="input half-width">
        <LabeledField
          label="Prefix"
          data-test="prefix"
        >
          <InputText
            size="large"
            formType="text"
            @input="(val) => (donorStore.donorInfo.prefix = val.target.value)"
            v-model="donorStore.donorInfo.prefix"
            data-test="prefix-input"
          >
          </InputText>
        </LabeledField>
      </div>
      <div class="input half-width">
        <LabeledField
          label="Suffix"
          data-test="suffix"
        >
          <InputText
            size="large"
            formType="text"
            @input="(val) => (donorStore.donorInfo.suffix = val.target.value)"
            v-model="donorStore.donorInfo.suffix"
            data-test="suffix-input"
          >
          </InputText>
        </LabeledField>
      </div>
      <div class="input half-width">
        <LabeledField
          label="Pronouns"
          data-test="pronouns"
        >
          <InputText
            size="large"
            formType="text"
            @input="(val) => (donorStore.donorInfo.pronouns = val.target.value)"
            v-model="donorStore.donorInfo.pronouns"
            data-test="pronouns-input"
          >
          </InputText>
        </LabeledField>
      </div>
      <div class="input half-width">
        <LabeledField
          label="Email*"
          data-test="email"
        >
          <InputText
            size="large"
            formType="text"
            :invalid-text="donorStore.errors.email || (donorStore.donorInfo.email === '' ? 'Email is required' : '')"
            :invalid="!!donorStore.errors.email || donorStore.donorInfo.email === ''"
            @input="
              (val) => {
                donorStore.donorInfo.email = val.target.value;
                if (donorStore.donorInfo.email === '') {
                  donorStore.errors.email = 'Email is required';
                } else {
                  donorStore.errors.email = '';
                }
              }
            "
            v-model="donorStore.donorInfo.email"
            data-test="email-input"
          >
          </InputText>
        </LabeledField>
      </div>
      <div class="input half-width">
        <LabeledField
          label="Phone"
          data-test="phone"
        >
          <InputText
            size="large"
            @input="(val) => (donorStore.donorInfo.homePhoneNumber = val.target.value)"
            v-model="donorStore.donorInfo.homePhoneNumber"
            data-test="phone-input"
          >
          </InputText>
        </LabeledField>
      </div>
      <div class="input half-width">
        <Skeletor
          v-if="!donorStore.countries.length"
          height="42px"
          class="skeletonTag"
          width="100%"
          pill
        />
        <LabeledField
          v-if="donorStore.countries.length"
          label="Country"
        >
          <Select
            size="large"
            option-label="label"
            option-value="value"
            data-test="country-select"
            :options="donorStore.countries.map((country) => ({ label: country.name, value: country.value }))"
            @change="
              (val) => {
                donorStore.donorInfo.country = val.value;
              }
            "
            v-model="donorStore.donorInfo.country"
            placeholder="Select a country"
          >
          </Select>
        </LabeledField>
      </div>
      <div class="input half-width">
        <LabeledField
          label="Street Address 1"
          data-test="address-line1"
        >
          <InputText
            size="large"
            formType="text"
            @input="(val) => (donorStore.donorInfo.addressLine1 = val.target.value)"
            v-model="donorStore.donorInfo.addressLine1"
            data-test="address-line1-input"
          >
          </InputText>
        </LabeledField>
      </div>
      <div class="input half-width">
        <LabeledField
          label="Street Address 2"
          data-test="address-line2"
        >
          <InputText
            size="large"
            formType="text"
            @input="(val) => (donorStore.donorInfo.addressLine2 = val.target.value)"
            v-model="donorStore.donorInfo.addressLine2"
            data-test="address-line2-input"
          >
          </InputText>
        </LabeledField>
      </div>
      <div class="input half-width">
        <LabeledField
          label="City"
          data-test="city"
        >
          <InputText
            size="large"
            formType="text"
            @input="(val) => (donorStore.donorInfo.city = val.target.value)"
            v-model="donorStore.donorInfo.city"
            data-test="city-input"
          >
          </InputText>
        </LabeledField>
      </div>
      <div
        style="display: flex; justify-content: space-between"
        class="input half-width"
      >
        <Skeletor
          v-if="
            donorStore.donorInfo.country == '936' && donorStore.donorInfo.country != '' && !donorStore.states.length
          "
          height="42px"
          class="skeletonTag"
          width="100px"
          pill
        />

        <LabeledField
          v-if="donorStore.donorInfo.country == '936' && donorStore.donorInfo.country != ''"
          label="State"
          data-test="state"
        >
          <Select
            size="large"
            option-label="name"
            option-value="value"
            style="padding-right: 4px; width: 100%"
            :options="donorStore.states"
            @change="
              (val) => {
                donorStore.donorInfo.state = val.value;
              }
            "
            v-model="donorStore.donorInfo.state"
            placeholder="Select a state"
            data-test="state-select"
          >
          </Select>
        </LabeledField>
        <LabeledField
          v-else-if="donorStore.donorInfo.country != '936' && donorStore.donorInfo.country != ''"
          label="State/Province"
          data-test="state-other"
        >
          <InputText
            size="large"
            formType="text"
            style="padding-right: 4px; width: 100%"
            @input="(val) => (donorStore.donorInfo.stateOther = val.target.value)"
            v-model="donorStore.donorInfo.stateOther"
            data-test="state-other-input"
          >
          </InputText>
        </LabeledField>

        <LabeledField
          label="Zip Code"
          data-test="zip"
        >
          <InputText
            size="large"
            formType="text"
            style="width: 100%"
            @input="(val) => (donorStore.donorInfo.zip = val.target.value)"
            v-model="donorStore.donorInfo.zip"
            data-test="zip-input"
          >
          </InputText>
        </LabeledField>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, computed, watch, nextTick, defineProps } from 'vue';
import { useDonorStore } from '@/stores/DonorStore.js';
import LabeledField from '@/components/forms/LabeledField.vue';

const props = defineProps({
  width: {
    type: String,
    required: false, // or `false` if you want it to be optional
    default: '400px',
  },
});
const width = ref(props.width);
const donorStore = useDonorStore();
donorStore.fetchStateCountry();
let isUpdatingState = false;
let isUpdatingStateOther = false;

watch(
  () => donorStore.donorInfo.state,
  (newState, oldState) => {
    if (newState !== oldState) {
      if (isUpdatingState) {
        isUpdatingState = false;
      } else {
        isUpdatingStateOther = true;
        donorStore.donorInfo.stateOther = null;
        nextTick(() => {
          isUpdatingState = false;
          isUpdatingStateOther = false;
        });
      }
    }
  },
);

watch(
  () => donorStore.donorInfo.stateOther,
  (newStateOther, oldStateOther) => {
    if (newStateOther !== oldStateOther) {
      if (isUpdatingStateOther) {
        isUpdatingStateOther = false;
      } else {
        isUpdatingState = true;
        donorStore.donorInfo.state = null;
        nextTick(() => {
          isUpdatingState = false;
          isUpdatingStateOther = false;
        });
      }
    }
  },
);
</script>
<style scoped lang="scss">
.input {
  padding: 0 4px 24px 4px;
  width: v-bind(width);
}
.half-width {
  width: calc(50% - 8px);
  margin-right: 16px;
}
.half-width:nth-child(2n) {
  margin-right: 0;
}
@media screen and (max-width: 1440px) {
  .input {
    width: 560px;
  }
  .half-width {
    width: 100%;
    margin-right: 0;
  }
}
</style>
